<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-4">
          <lib-page-header page-title="TRANSFERÊNCIAS BANCÁRIAS"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/payment-method.png">
          </lib-page-header>
        </div>
        <div class="col-8">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/transferencias-bancarias']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-9">
          <div class="form-row">
            <lib-divisor altura="140px" imagem="assets/img/global/manage_sources.png"></lib-divisor>
            <div class="col-md-11 col-lg-11 col-xl-11">
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="data_transfere">Data Transferência</label>
                  <p-calendar #InputFocus id="data_transfere" formControlName="data_transfere"
                    inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR"
                    [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
                <div class="col-md-5">
                  <label for="documento">Espécie</label>
                  <select #especie_ formControlName="especie" name="selectEspecie" class="custom-select">
                    <option [value]="item.id" *ngFor="let item of listaEspecies">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="documento">Documento</label>
                  <input formControlName="documento" type="text" class="form-control" id="documento">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="valor_transfere">Valor</label>
                  <input unmask="true" [imask]="imaskConfig" formControlName="valor_transferido" type="text"
                    class="form-control text-right" id="valor_transferido" style="font-weight: bold; color: #1e88e5">
                </div>
              </div>
            </div>
          </div>

          <div class="form-row mt-3">
            <lib-divisor altura="130px" imagem="assets/img/global/text_exports.png"></lib-divisor>
            <div class="col-md-11 col-lg-11 col-xl-11">
              <div class="col-12 mb-2 font-weight-bold">
                Conta Pagadora
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <select [(ngModel)]="orgaoPagadora" [ngModelOptions]="{standalone: true}" [compareWith]="compareFn"
                    class="custom-select" (change)="carregarPagadora()">
                    <option [ngValue]="item" *ngFor="let item of listaOrgaos">
                      {{item.codigo}} {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-12">
                  <div class="col-md-2 p-0 m-0 float-left">
                    <input class="form-control" type="text" (blur)="pagadoraAutoComplete.atualizar(false)"
                      [(ngModel)]="pagadoraAutoComplete.id" name="conta_pagadora_id"
                      [ngModelOptions]="{standalone: true}" *ngIf="pagadoraAutoComplete" />
                  </div>
                  <div class="form-group col-md-10 p-0 float-left">
                    <p-autoComplete formControlName="conta_pagadora" [field]="pagadoraAutoComplete.conversor"
                      [suggestions]="pagadoraAutoComplete.lista" (completeMethod)="pagadoraAutoComplete.filtrar($event)"
                      placeholder="Informe a conta pagadora" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="pagadoraAutoComplete.atualizar(true)"
                      (onBlur)="pagadoraAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                      [dropdown]="true" (onDropdownClick)="pagadoraAutoComplete.onDropDownClick($event)"
                      *ngIf="pagadoraAutoComplete">
                      <ng-template let-conta_pagadora pTemplate="item">
                        {{conta_pagadora.nome}} {{conta_pagadora.numero_conta}} {{conta_pagadora.digito_conta}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <lib-divisor altura="130px" imagem="assets/img/global/text_imports.png"></lib-divisor>
            <div class="col-md-11 col-lg-11 col-xl-11">
              <div class="col-12 mb-2 font-weight-bold">
                Conta Recebedora
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <select [(ngModel)]="orgaoRecebedora" [ngModelOptions]="{standalone: true}" [compareWith]="compareFn"
                    class="custom-select" (change)="carregarRecebedora()">
                    <option [ngValue]="item" *ngFor="let item of listaOrgaos">
                      {{item.codigo}} {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-12">
                  <div class="col-md-2 p-0 m-0 float-left">
                    <input class="form-control" type="text" (blur)="recebedoraAutoComplete.atualizar(false)"
                      [(ngModel)]="recebedoraAutoComplete.id" name="conta_recebedora_id"
                      [ngModelOptions]="{standalone: true}" *ngIf="recebedoraAutoComplete" />
                  </div>
                  <div class="form-group col-md-10 p-0 float-left">
                    <p-autoComplete formControlName="conta_recebedora" [field]="recebedoraAutoComplete.conversor"
                      [suggestions]="recebedoraAutoComplete.lista"
                      (completeMethod)="recebedoraAutoComplete.filtrar($event)" placeholder="Informe a conta recebedora"
                      inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }"
                      (onSelect)="recebedoraAutoComplete.atualizar(true)"
                      (onBlur)="recebedoraAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                      [dropdown]="true" (onDropdownClick)="recebedoraAutoComplete.onDropDownClick($event)"
                      *ngIf="recebedoraAutoComplete">
                      <ng-template let-conta_recebedora pTemplate="item">
                        {{conta_recebedora.nome}} {{conta_recebedora.numero_conta}} {{conta_recebedora.digito_conta}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card">
            <h6 class="p-2 text-center m-0">Saldos</h6>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <span style="display: block;">Pagadora</span>
                <span class="float-right">{{+saldoPagadora | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item">
                <span style="display: block;">Recebedora</span>
                <span class="float-right">{{+saldoRecebedora | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item font-weight-bold">
                <span style="display: block;">Disponível</span>
                <span class="float-right font-weight-bold">{{+saldoPagadora -
                  +entidadeForm.get('valor_transferido').value | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Sair" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>